module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-800italic.woff2?c62c3eea77cf3fca51494e8c924adf4d";